import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function useEmailWriteReviewCtaRedirectionExperiment(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.EMAIL_WRITE_REVIEW_CTA_REDIRECTION)
  return experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW
}
